/** Generated from package.json by build.mjs — do not edit by hand. */
export const VERSION = "0.4.0";
